import { Link, router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'

export default function ConversationsIndex({ conversations = [], currentUser }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex items-center justify-between px-4 py-4">
          <h1 className="text-xl font-bold">Live Triage</h1>
          <div className="flex items-center gap-4">
            <Link href="/dashboard"><Button variant="ghost" size="sm">Dashboard</Button></Link>
            <Link href="/admin/agents"><Button variant="ghost" size="sm">Agents</Button></Link>
            <span className="text-sm text-muted-foreground">{currentUser?.email}</span>
          </div>
        </div>
      </header>
      <main className="container mx-auto max-w-5xl px-4 py-10">
        <h2 className="text-2xl font-semibold tracking-tight">Conversations</h2>
        <div className="mt-6 overflow-hidden rounded-lg border bg-card">
          <table className="w-full text-sm">
            <thead className="border-b bg-muted/40">
              <tr className="text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
                <th className="px-4 py-3">UUID</th>
                <th className="px-4 py-3">Agent</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Patient</th>
                <th className="px-4 py-3">Started</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {conversations.map((c) => (
                <tr key={c.id} className="cursor-pointer hover:bg-muted/30" onClick={() => router.visit(`/admin/conversations/${c.id}`)}>
                  <td className="px-4 py-3 font-mono text-xs">{c.uuid.slice(0, 8)}</td>
                  <td className="px-4 py-3">{c.agent_name}</td>
                  <td className="px-4 py-3 text-xs">{c.status}</td>
                  <td className="px-4 py-3">{[c.first_name, c.last_name].filter(Boolean).join(' ') || '—'}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{c.started_at ? new Date(c.started_at).toLocaleString() : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  )
}
